"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumAddType = void 0;
exports.EnumAddType = {
    Task: 'Task',
    Medication: 'Medication',
    Document: 'Document',
    Contact: 'Contact',
    Profile: 'Profile',
};
//# sourceMappingURL=enum-add-type.js.map